import { ChangeDetectionStrategy, Component, computed, input, model, output, ViewEncapsulation } from '@angular/core';
import { SimButtonModule } from '@simOn/ui/sim-button';
import { BaseSimIconType, SimIconComponent } from '@simOn/ui/sim-icon';

export type TSystemMessageType = 'error' | 'info' | 'warning' | 'success';
const SystemMessageIcon: Record<TSystemMessageType, { icon: BaseSimIconType | undefined; color?: string | undefined }> =
  {
    error: {
      icon: 'error_outline',
      color: 'var(--ui-accent-darker)'
    },
    info: {
      icon: undefined
    },
    success: {
      icon: 'check_outline',
      color: 'var(--status-success-default)'
    },
    warning: {
      icon: 'sub-error',
      color: 'var(--status-warn-default)'
    }
  } as const;
@Component({
    selector: 'system-message',
    imports: [SimIconComponent, SimButtonModule],
    template: `
    @if(icon().icon){
    <sim-icon class="ui-system-message__icon" [sizeInPx]="24" [icon]="icon().icon" [color]="icon().color" />
    }
    <div class="ui-system-message__message">{{ message() }}</div>
    @if(isClosable()){
    <button type="button" sim-icon-button (click)="close.emit(index())">
      <sim-icon icon="close2" color="#3F484D" />
    </button>
    }
  `,
    styleUrl: './system-message.component.scss',
    host: {
        class: 'ui-system-message',
        '[class.error]': `type() === 'error'`,
        '[class.warning]': `type() === 'warning'`,
        '[class.success]': `type() === 'success'`,
        '[class.info]': `type() === 'info'`
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SystemMessageComponent {
  readonly message = model<string>('');
  readonly type = model<TSystemMessageType>('info');
  readonly isClosable = model<boolean>(false);
  readonly icon = computed(() => SystemMessageIcon[this.type()]);
  readonly close = output<number>();
  readonly index = input<number>(0);
}
